// extracted by mini-css-extract-plugin
export default {"content":"styles_content__oUlzk","image":"styles_image__lEV5p"};